module.exports = __webpack_public_path__ + "img/Media Library-01.7be91d49.png";